export { SearchBase as Search } from './SearchBase'
export type { SearchProps } from './SearchBase'
